import { Text } from "react-internationalization";
import React from "react";
import { useSelector } from "react-redux";

const DashboardServices = ({
  searchExistingHandler,
  redirect,
  theme,
  isSuperUser,
  isAgencyAdmin,
  redirectToCampaign,
  redirectToProspect,
  states,
  redirectToBulkUploadCampaign,
  redirectToBulkUpload,
  redirectToCalendar,
  redirectToSearchUser,



}) => {
  const { supportingServices } = useSelector((state) => state.login);
  const {
    searchappl,
    campaignState,
    prospectState,
    bulkUploadCampaign,
    bulkUploadProspect,
    eventCalState,
    searchUserState,
  } = states;
  return (
    <nav className="navbar1 navbar-dark custNavBar custNavBar3">
      <a
        className={
          searchappl
            ? "nav-link-selected1"
            : "navbar-brand navig-link navig-link-hline"
        }
        onClick={() => searchExistingHandler()}
      >
        Dashboard
      </a>

      <a
        className="navbar-brand navig-link navig-link-hline"
        onClick={(e) => redirect(e)}
      >
        Create New Application
      </a>

      {theme === "Default" &&
        supportingServices.map((service) => (
          <React.Fragment key={service}>
            {!isSuperUser && (
              <>
                {service === "ENRLSVC1" && (
                  <a
                    className={
                      campaignState
                        ? "nav-link-selected1"
                        : "navbar-brand navig-link navig-link-hline"
                    }
                    onClick={() => redirectToCampaign()}
                  >
                    Campaign Management
                  </a>
                )}
                {service === "ENRLSVC2" && (
                  <a
                    className={
                      prospectState
                        ? "nav-link-selected1"
                        : "navbar-brand navig-link navig-link-hline"
                    }
                    onClick={() => redirectToProspect()}
                  >
                    Prospect Management
                  </a>
                )}
              </>
            )}
            {isSuperUser && (
              <>
                {service === "ENRLSVC1" && (
                  <div
                    className={
                      "dropdown " +
                      (campaignState || bulkUploadCampaign
                        ? "nav-link-selected1 navpadding"
                        : "")
                    }
                  >
                    <a
                      className="navprospect dropbtn"
                      onClick={() => redirectToCampaign()}
                    >
                      Campaign Management&nbsp;
                      <i className="fa fa-caret-down"></i>
                    </a>
                    <div
                      className="dropdown-content cursor-pointer"
                      id="myDropdown"
                    >
                      <a
                        className={
                          campaignState || bulkUploadCampaign
                            ? "dropdown-item bulkdropdwnactive"
                            : "dropdown-item bulkdropdwn"
                        }
                        onClick={() => redirectToBulkUploadCampaign()}
                      >
                        <Text>Campaign Bulk Upload</Text>
                      </a>
                    </div>
                  </div>
                )}
                {service === "ENRLSVC2" && (
                  <div
                    className={
                      "dropdown " +
                      (prospectState || bulkUploadProspect
                        ? "nav-link-selected1 navpadding"
                        : "")
                    }
                  >
                    <a
                      className="navprospect dropbtn"
                      onClick={() => redirectToProspect()}
                    >
                      Prospect Management&nbsp;
                      <i className="fa fa-caret-down"></i>
                    </a>
                    <div
                      className="dropdown-content cursor-pointer"
                      id="myDropdown"
                    >
                      <a
                        className={
                          prospectState || bulkUploadProspect
                            ? "dropdown-item bulkdropdwnactive"
                            : "dropdown-item bulkdropdwn"
                        }
                        onClick={() => redirectToBulkUpload()}
                      >
                        <Text>Prospect Bulk Upload</Text>
                      </a>
                    </div>
                  </div>
                )}
              </>
            )}
            {service === "ENRLSVC3" && (
              <a
                className={
                  eventCalState
                    ? "nav-link-selected1"
                    : "navbar-brand navig-link navig-link-hline"
                }
                onClick={() => redirectToCalendar()}
              >
                Calendar
              </a>
            )}

            {!isAgencyAdmin && isSuperUser && service === "ENRLSVC4" && (

              <a
                className={
                  searchUserState
                    ? "nav-link-selected1"
                    : "navbar-brand navig-link navig-link-hline"
                }
                onClick={() => redirectToSearchUser()}
              >
                User Management
              </a>
            )}
            {service === "ENRLSVC5" && (
              <a
                className={"navbar-brand navig-link navig-link-hline"}
                target="_blank"
                rel="noopener noreferrer"
                href="https://dev.medadvantage360.com/commission-ui/"
              >
                CommissionPlus
              </a>
            )}
          </React.Fragment>
        ))}
    </nav>
  );
};

export default DashboardServices;
